import React, { useState } from 'react';

import { LightHeaderPanel } from 'apps/promo/components/common/fromAuth/LightHeaderPanel/LightHeaderPanel';
import PromoModalComponent from 'apps/promo/components/utils/PromoModalComponent';

import PromoFullCountryList from './PromoFullCountryList';
import { PromoFullViewCountrySearch } from './PromoFullViewCountrySearch';
import { PromoInputSearch } from './PromoInputSearch';

const PromoSelectCountryWithCode = (props) => {
    const [isFullViewSearch, toggleIsFullViewSearch] = useState(false);

    const toggleSearch = (e, show) => {
        e.preventDefault();
        toggleIsFullViewSearch(show);
    };

    return (
        <>
            {isFullViewSearch ? (
                <PromoFullViewCountrySearch
                    countries={props.countries}
                    placeholder={props.searchFullPlaceholder}
                    searchNoResult={props.searchNoResult}
                    toggleSearch={toggleSearch}
                    onCountryItemClick={props.onCountryItemClick}
                    countryWithCode={props.countryWithCode}
                    iso2={props.iso2}
                />
            ) : (
                <PromoModalComponent isIconClose modalRef={props.modalRef}>
                    <LightHeaderPanel title={props.searchModalTitle} />
                    <PromoInputSearch placeholder={props.searchPlaceholder} toggle={toggleSearch} />
                    <PromoFullCountryList countries={props.countries} iso2={props.iso2} onCountryItemClick={props.onCountryItemClick} />
                </PromoModalComponent>
            )}
        </>
    );
};

export default PromoSelectCountryWithCode;
